import {Typography} from '@mui/material';
import {DlMuiDynamicIcon} from '@wallaby-ui/core';
import React from 'react';
import {useIntl} from 'react-intl';

import {SelectParams, getSelectOptions} from './LightSelectFilter';

type Props = {
  style?: React.CSSProperties;
  maxWidth?: string | number;
  label: string;
  params?: SelectParams;
  chips?: any[];
  text?: string;
  noDataText?: string;
};
export const LightPreviewBox: React.FC<Props> = (props) => {
  const {style, maxWidth = 362, label, params, chips, text, noDataText} = props;
  const intl = useIntl();
  const {renderTags} = getSelectOptions(intl, params);
  const getTagProps = () => {
    return {className: 'dl-preview-box-chip'};
  };
  const isEmpty = !chips?.length && !text && noDataText;
  return (
    <div className='dl-preview-box' style={{maxWidth, ...(style ?? {})}}>
      {isEmpty ? (
        <div className='dl-preview-box-empty'>
          <DlMuiDynamicIcon iconName='infoIcon' useFixedViewBox={16} svgIconStyle={{fontSize: 16}} />
          <span>{noDataText}</span>
        </div>
      ) : (
        <>
          <Typography style={{marginTop: 8, marginBottom: 4, paddingLeft: 1, color: 'var(--dlThemeGray-800)'}} variant='labelBold'>
            {label}
          </Typography>
          {
            <div className='dl-preview-box-chips'>
              {chips && renderTags(chips, getTagProps)}
              {text && <span className='dl-preview-box-text'>{text}</span>}
            </div>
          }
        </>
      )}
    </div>
  );
};
